import { FileText, Table } from 'lucide-react';

import { StyleFormat } from '../../../../../../../backend/src/types/types';

interface DownloadFormatSelectorProps {
  onSelectFormat: (format: StyleFormat) => void;
}

const DownloadFormatSelector = ({ onSelectFormat }: DownloadFormatSelectorProps) => {
  const allFormats = [
    {
      id: StyleFormat.Table,
      label: 'Table',
      icon: <Table />,
      color: 'text-green-600',
      text: 'Word or Excel',
    },
    {
      id: StyleFormat.Written,
      label: 'Written',
      icon: <FileText />,
      color: 'text-blue-600',
      text: 'Word',
    },
  ];

  return (
    <div className="flex flex-row justify-center gap-6 rounded-xl bg-gray-50 p-6 shadow-md">
      {allFormats.map((format) => (
        <div
          key={format.id}
          className={`group flex w-64 cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-gray-200 bg-white px-8 py-6 transition-all duration-200 hover:border-blue-400 hover:bg-blue-50 hover:shadow-xl`}
          onClick={() => onSelectFormat(format.id)}
        >
          <div
            className={`mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-blue-100 text-4xl text-blue-600 transition-colors duration-200 group-hover:bg-blue-200`}
          >
            {format.icon}
          </div>
          <span className="mb-1 text-lg font-semibold text-gray-800">{format.label}</span>
          <span className="text-center text-sm text-gray-500">{format.text}</span>
        </div>
      ))}
    </div>
  );
};

export default DownloadFormatSelector;
